// Utility to trigger download
/**
 * @param url url to download
 * @param filename filename of excel file
 * @returns Download File
 */
const DownloadFile = (url: string, filename: string) => {
  const element = document.createElement("a");
  element.href = url;
  element.download = filename;
  element.target = "_blank";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export default DownloadFile;